<template>
    <van-cell-group >
        <van-cell title="报价方案:"  :value="formData.proposal" />
        <van-cell title="要件清单类型:"  :value="formData.accountFlag" />
        <van-cell title="个人账户回款:" :value="formData.personalAccount"  v-if="formData.accountFlag=='个人账户回款'"/>
        <van-cell title="公户回款:" :value="formData.enterpriseAccount" v-if="formData.accountFlag=='公户回款'"/>
        <van-cell title="是否配资:" :value="formData.fundingFlag" />
        <van-cell title="配资金额:" :value="formData.fundingAmount" v-if="formData.fundingFlag=='是'"/>
        <van-cell title="下户要求:" :value="formData.dueDiligence" />
        <van-cell title="核行注意事项:" :value="formData.attention" />
        <van-cell title="公证:" :value="formData.notarization" />
        <van-cell title="其他要求:" :value="formData.other" />
        <van-cell title="预约面谈时间:" :value="formData.appointmentsDate|moment" />
        <van-cell title="预计核上家一押:" :value="formData.checkFirstDate|moment" />
        <van-cell title="预计核上家二押:" :value="formData.checkSecondDate|moment" />
        <van-cell title="预计核下家:" :value="formData.checkNextDate|moment" />
        <van-cell title="预计公证:" :value="formData.notaryDate|moment" />
    </van-cell-group>
</template>

<script>
    import { debounce} from 'lodash'
    import {saveFormData,getFormData} from '@/api/foreclosure'
    export default {
        name: 'plan_view',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                formData:{}
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            loadData() {
                const self = this
                let params = {
                    applyId: this.applyId,
                    formModule: 'F_RiskFirst'
                }
                getFormData(params).then(res => {
                    let data={}
                    if (res.success) {
                        res.data!=null&&res.data.forEach((item,index)=>{
                            data[item.ext]=item.info
                        })
                        debounce(() => {
                            self.formData=data
                        },200)()
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
